import {DialogSeen} from '../../../../../controls/agyle/clinician/clinitian';
import React from 'react';
import {useTranslation} from 'react-i18next';
import _ from 'lodash';
import moment from 'moment/moment';
import keyPerformanceIndicator from '../../../../../util/timeMarker';
import {getConfig} from '../../../../../util/configUtil';
import {hasPermission, Permissions} from '../../../../../store/reducers/user';
import {useDispatch} from 'react-redux';
import {consultantDictionary} from '../../../../../controls/agyle/clinician/clinitianUtils';
import { findArrivedSlotAndUpdateToBeingSeen } from '../../../../../store/reducers/appointments';

const CurrentClinicianForm = (props) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const {clinicianFormType} = props;
    const isNurse = clinicianFormType === 'currentNurse' || clinicianFormType === 'currentNurseIP';

    const canSetClinician = dispatch(hasPermission(Permissions.AGYLE_CAN_SET_CLINICIAN));

    // Configs
    const currentClinicianTimeToTreatment = getConfig('currentClinicianTimeToTreatment');
    const schedulerModuleEnabled = getConfig('modules.scheduler.enabled', false);

    let allowedConsultants = null;
    if (clinicianFormType !== 'currentClinician') {
        allowedConsultants = isNurse ? consultantDictionary.currentNurse : consultantDictionary.clerking;
    }

    const getPath = () => {
        switch (clinicianFormType) {
            case 'currentNurse':
                return 'studies.edau.currentNurse';
            case 'currentNurseIP':
                return 'currentNurse';
            case 'currentClinician':
            default:
                return 'currentClinician';
        }
    };

    const handleCurrentClinician = (value) => {
        const path = getPath();
        const dataToSave = [];
        const timestamp = moment().toISOString();

        if (_.isNil(value)) {
            dataToSave.push({
                name: path,
                value: null,
            });
        } else {
            dataToSave.push({
                    name: path,
                    value: {
                        ...value,
                        timestamp,
                    },
                },
            );
        }

        if (clinicianFormType === "currentClinician" && !props.patient?.currentClinician && value && schedulerModuleEnabled) {
            dispatch(findArrivedSlotAndUpdateToBeingSeen(props.patient?.__id, props.patient?.patient?.hospitalNumber));
        }

        if (!isNurse && currentClinicianTimeToTreatment && !_.isNil(value)) {
            keyPerformanceIndicator(
                dataToSave,
                props.patient,
                ['firstClinicianSaved'],
                {
                    when: timestamp,
                    who: value,
                },
            );
        }
        props.onChange(dataToSave);
    };

    const changeFirstClinician = (value) => {
        let data = [{name: 'firstClinician', value: value}];
        if (!props.patient.currentClinician && value.who) {
            data.push({
                name: 'currentClinician',
                value: {
                    ...value.who,
                    timestamp: moment().toISOString(),
                },
            });
        }

        keyPerformanceIndicator(
            data,
            props.patient,
            ['firstClinicianSaved'],
            {
                when: value?.when,
                who: value?.who,
            },
        );
        props.onChange(data);
    };

    const getValue = () => {
        switch (clinicianFormType) {
            case 'currentClinician':
                return props.patient?.currentClinician;
            case 'firstClinician':
                return props.patient?.firstClinician;
            case 'currentNurse':
                return props.patient?.studies?.edau?.currentNurse;
            case 'currentNurseIP':
                return props.patient?.currentNurse;
            default:
                return null;
        }
    };

    const getLabel = () => {
        switch (clinicianFormType) {
            case 'firstClinician':
                return 'First Clerking Clinician';
            case 'currentNurse':
                return 'Current Nurse';
            case 'currentNurseIP':
                return 'Nurse';
            case 'currentClinician':
            default:
                return 'Current Clinician';
        }
    };

    return (
        <DialogSeen
            patient={props.patient}
            size="large"
            disableSave={props.disableSave}
            disableDateManipulation={clinicianFormType === 'currentClinician'}
            open={props.open}
            onClose={props.onClose}
            triageNotOpenAgain
            withSpeciality={props.withSpeciality}
            patientType={props.patientType}
            handleLastObs={props.handleLastObs}
            allowedConsultants={allowedConsultants}
            patientHaveModification={props.haveModification}
            label={t(getLabel())}
            nurse={isNurse}
            value={getValue() || null}
            onChange={(value) => {
                if (clinicianFormType === 'firstClinician') changeFirstClinician(value);
                if (props.withSpeciality) handleCurrentClinician(value);
                else handleCurrentClinician(isNurse ? value : value?.who);
            }}
            refresh
        />
    );
};


export default CurrentClinicianForm;